import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Booking from "../screens/auth/Booking";
import Profile from "../screens/auth/Profile";
import ProjectListing from "../screens/users/ProjectListing";
import Blog from "../screens/users/Blogs";
import BlogDetails from "../screens/users/BlogDetails";
import ProjectDetails from "../screens/users/ProjectDetails";
import User from "../screens/auth/User";
import AdminBlog from "../screens/auth/AdminBlog";
import Project from "../screens/auth/Project";
import UserLogin from "../screens/nonAuth/UserLogin";
import UserBlogDetails from "../components/BlogPageComponent/UserBlogDetails";
import InvestmentCorner from "../screens/users/InvestmentCorner";
import Inquiries from "../screens/auth/Inquiries";
import Testimonial from "../screens/auth/Testimonial";
import Faqs from "../screens/auth/Faqs";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/admin-projects",
    component: <Project />,
  },
  {
    path: "/inquiries",
    component: <Inquiries />,
  },
  {
    path: "/adminblog",
    component: <AdminBlog />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/users",
    component: <User />,
  },
  {
    path: "/testimonials",
    component: <Testimonial />,
  },
  {
    path: "/faqs",
    component: <Faqs />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/admin-login",
    component: <Login />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
  {
    path: "/user-login",
    component: <UserLogin />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/projects",
    component: <ProjectListing />,
  },
  {
    path: "/blogs",
    component: <Blog />,
  },
  {
    path: "/blogs/blogDetails/:id",
    component: <UserBlogDetails />,
  },
  {
    path: "/projects/project-details/:id",
    component: <ProjectDetails />,
  },
  {
    path: "/investment-corner",
    component: <InvestmentCorner />,
  },
];
